import { stringifyQs } from "@dashboard/utils/urls";

export type AnalyticsTab = "sales" | "products" | "customers" | "inventory" | "finance" | "ledger";

export type AnalyticsPeriod = "day" | "month" | "year" | "custom" | "ledger";

export interface AnalyticsPageUrlQueryParams {
  tab?: AnalyticsTab;
  period?: AnalyticsPeriod;
  startDate?: string;
  endDate?: string;
  slot?: string;
  channel?: string;
}

export const analyticsSection = "/analytics";
export const analyticsPath = `${analyticsSection}/`;

export const analyticsUrl = (params?: AnalyticsPageUrlQueryParams) =>
  analyticsPath + (params ? `?${stringifyQs(params)}` : "");
